import React, { PureComponent, Fragment } from 'react'
import NavBar from "./navigation/nav-bar"
import NavProgressReports from './navigation/nav-progress-reports'
import NavMainAftergameLinks from './navigation/nav-main-aftergame-links'
import ProgressReportsPageHero from './ui/progress-reports-page-hero'
import ParameterFilter from './ui/parameter-filter'
import DriverProgressCard from './progress-reports/driver-progress-card'
import { findIndex } from 'lodash-es'
import { formPagePath } from '../utilities/route'
import {
  hasEnoughRespondents,
  getPreviousSurveyId,
  getDriversProgressResults,
  hasLatestResults,
} from '../utilities/progress-reports'
import { sortingService } from '../utilities/sortingService'
import PrSortingWidget from './ui/sorting-widget-progress-reports'

class ProgressReportsDrivers extends PureComponent {

  handleFiltersChange = value => {
    this.props.onSetPrFilters(value);
  }

  render() {
    const {
      respondentParameters,
      match: {
        params: { surveyId, languageCode },
      },
      questionnaire,
      questionnaire: {
        canViewAfterGame,
        logo,
        isFinished,
        isAfterGameGuest,
        isDialogueActive,
        catalysts,
        surveySequence
      },
      useTranslate,
      currentSurveyStatistics,
      previousSurveyStatistics,
      prSortingType,
      sortAscending,
      prFilters,
      improvementProject,
    } = this.props;

    const toThemes = formPagePath(languageCode, surveyId, 'finish', 'themes');
    const previousSurveyId = getPreviousSurveyId(surveySequence, surveyId);
    const driverProgressResults = getDriversProgressResults(
      currentSurveyStatistics, previousSurveyStatistics, questionnaire, surveyId, previousSurveyId
    );
    const sortedResults = [...driverProgressResults];
    const sortingFunction = sortingService.getSortingFunction(prSortingType);
    sortedResults.sort(sortingFunction(sortAscending));

    const enoughRespondents = hasEnoughRespondents(currentSurveyStatistics) ||
      hasEnoughRespondents(previousSurveyStatistics);

    return (
      <section className="finish-page">
        <ProgressReportsPageHero>
          <div className="aftergame-page-container">
            <NavBar
              to={isFinished && !canViewAfterGame && toThemes}
              afterGame
              logo={logo}
              canViewAfterGame={canViewAfterGame}
              isAfterGameGuest={isAfterGameGuest}
            >
              {(canViewAfterGame || isAfterGameGuest) &&
                <NavMainAftergameLinks
                  activePage={"progress"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  isDialogueActive={isDialogueActive}
                  showProgressReports={true}
                  improvementProject={improvementProject}
                />
              }
            </NavBar>
          </div>
          <div className="aftergame-page-container">
            <div className="finish-page__intro">
              <h1>{useTranslate("progress_reports.progress_page_title")}</h1>
              <div className="stats-description">
                <p>{useTranslate("progress_reports.progress_page_description")}</p>
              </div>
              <div className="finish-page__intro__nav-holder">
                <NavProgressReports
                  activePage={"drivers"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  questionnaire={questionnaire}
                />
              </div>
            </div>
          </div>
        </ProgressReportsPageHero>

        <div className="aftergame-page-container statistics-page-content finish-page__stats pb-5">
          <div className="finish-page__filters">
            {respondentParameters.length > 0  && (
              <ParameterFilter
                filters={prFilters}
                handleFiltersChange={this.handleFiltersChange}
                respondentParameters={respondentParameters}
                isAfterGameGuest={isAfterGameGuest}
                useTranslate={useTranslate}
                disableYouParameter={false}
              />
            )}
            <PrSortingWidget
              disabled={!hasLatestResults(sortedResults)}
              useTranslate={useTranslate}
            />
          </div>

          {enoughRespondents ?
            <Fragment>
              {sortedResults.map((driver, index) => {
                return (
                  <DriverProgressCard
                    key={index}
                    index={index}
                    driver={driver}
                    showThemeTitle={true}
                    themeIndex={findIndex(catalysts, (c) => c.title === driver.catalystTitle)}
                    useTranslate={useTranslate}
                    showLabels={index < 1}
                    showPrevious={true}
                    showStatements={true}
                    mode={"card"}
                  />
                )
              })}
            </Fragment>
            :
            <p className="no-results">{useTranslate("progress_reports.no_progress_reports_for_parameter")}</p>
          }

        </div>
      </section>
    );
  }
}

export default ProgressReportsDrivers;



// WEBPACK FOOTER //
// ./src/components/progress-reports-drivers.js